export default "__VITE_ASSET__DOelp8IE__"